<div class="input-container">
  <label [for]="controlId()">{{ label() }}</label>

  @if (inputType() === 'textarea') {
    <textarea
      class="input-container__input input-container__textarea"
      [id]="controlId()"
      [placeholder]="placeholder()"
      [value]="value"
      (input)="onInput($event)"
      (blur)="onBlur()"
    ></textarea>
  } @else {
    <input
      class="input-container__input"
      type="text"
      [id]="controlId()"
      [placeholder]="placeholder()"
      [value]="value"
      (input)="onInput($event)"
      (blur)="onBlur()"
    />
  }

  @let status = displayError();
  @if (status === 'empty' || status === 'invalid') {
    @let message =
      status === 'empty' ? ('staff.createStaff.emptyError' | translate) : customMessage();
    <div class="error-message">{{ message }}</div>
  }
</div>
